/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_User_Not_JoinedInputs */



/**
* | output |
* | --- |
* | "User has not joined the organization yet." |
*
* @param {Members_User_Not_JoinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_user_not_joined = /** @type {((inputs?: Members_User_Not_JoinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_User_Not_JoinedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Benutzer ist der Organisation noch nicht beigetreten.")
	return /** @type {LocalizedString} */ ("User has not joined the organization yet.")
});